import React from 'react'

export default function Site() {
  return (
    <div>This is main page</div>
  )
}
